import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const EmpoweringGrowth = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner1">
        <div className="banner-overlay1"></div>
        <div className="banner-content">
          <h1 className="banner-title">Empowering Growth</h1>
          <p>
            Transform your business with solutions designed to unlock new growth
            opportunities, <br /> enhance scalability, and foster long-term
            success. Our approach combines innovation with data-driven insights{" "}
            <br /> to propel your business forward.
          </p>
          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>

        {/* Add the image element */}
        <img
          className="banner-image"
          src="https://img.freepik.com/free-photo/woman-drawing-graph_329181-1018.jpg"
          alt="Empowering Growth Solutions"
        />
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="text-center">Overview</h2>
              <p className="text-center">
                At Empowering Growth, we specialize in helping businesses
                leverage cutting-edge technology, data, and strategies to
                achieve sustainable growth. We empower organizations to scale
                effectively, streamline operations, and achieve their business
                goals.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="container-fluid bg-light" style={{ padding: 40 }}>
        <div className="row serv_h1 mb-4">
          <div className="col-md-12">
            <div className="serv_h1l mb-4">
              <h2 className="text-center">Case Studies</h2>
              <p className="text-center mb-0">
                Check out these real-world case studies where we helped
                businesses achieve transformative growth with innovative
                solutions.
              </p>
            </div>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h4 className="mb-3 card-title">AI-Powered Retail Expansion</h4>
              <p className="mb-4">
                Our AI-driven analytics platform helped a large retail company
                identify high-demand products, optimize stock levels, and expand
                their customer base. By utilizing predictive analytics, they
                increased their revenue by 35% in just one quarter, enabling
                them to scale their operations smoothly.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h4 className="mb-3 card-title">
                Customer Experience Transformation
              </h4>
              <p className="mb-4">
                By implementing an advanced customer experience platform, we
                helped a telecommunications company improve customer
                satisfaction by 25%. With personalized services and AI-powered
                chatbots, the company achieved faster response times, reducing
                churn and increasing customer retention rates by 18%.
              </p>
            </div>
          </div>
        </div>
      </div>

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4 pt-5 bg-black text-white pb-5 mx-0 px-4">
            <div className="col-md-8">
              <div className="serv_h3l">
                <h2>Ready to Empower Your Growth?</h2>
                <p className="mt-3">
                  Schedule a consultation today to learn how our solutions can
                  help you achieve sustainable growth and success.
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/colleagues-working-together-office_23-2148738266.jpg"
                        className="w-100"
                        alt="Empower Growth Consultation"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EmpoweringGrowth;
